import { Injectable } from '@angular/core';
import { Router, Scroll, NavigationEnd, NavigationStart } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter, distinctUntilChanged } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScrollHandlerService {
  private isNavigatingBack = false;
  private navigationId = 0;
  
  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller
  ) {
    // Erkennen der Navigationsrichtung
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
      // Bei Browser-Zurück-Button (popstate)
      if (event.navigationTrigger === 'popstate') {
        // Sichere Typprüfung mit optionaler Verkettung
        this.isNavigatingBack = !!event.restoredState && 
                                 'navigationId' in event.restoredState &&
                                 event.restoredState.navigationId < this.navigationId;
      } else {
        this.isNavigatingBack = false;
      }
    });

    // Aktualisiere navigationId
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.navigationId = event.id;
    });

    // Behandlung der Scroll-Position
    this.router.events.pipe(
      filter(event => event instanceof Scroll),
      distinctUntilChanged() // Verhindert doppelte Scroll-Events
    ).subscribe((event: Scroll) => {
      // Warte eine kurze Zeit, um sicherzustellen, dass das DOM vollständig gerendert ist
      setTimeout(() => {
        if (this.isNavigatingBack && event.position) {
          // Bei Rückwärts-Navigation
          this.viewportScroller.scrollToPosition(event.position);
        } else if (event.anchor) {
          // Bei Anker-Navigation
          this.viewportScroller.scrollToAnchor(event.anchor);
        } else {
          // Bei normaler (Forward-)Navigation
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      }, 100);
    });
  }
}